export default __webpack_public_path__ + "static/media/Endeavor.ecbc2dd2.svg";